// Prenos datoteke v brskalniku, ki deluje tudi na iPhonu (Safari/WebKit) - task #241484.
// iOS Safari ne prenese data: URL-ja z atributom download, ignorira klik na povezavo, ki ni v DOM-u, in ne dovoli
// znaka ":" v imenu datoteke. Zato se data: URL pretvori v Blob (object URL), povezava se začasno doda v body,
// iz imena pa se odstranijo nedovoljeni znaki. Na ostalih brskalnikih je prenos enak kot prej.

// object URL mora ostati veljaven, dokler brskalnik ne prebere datoteke (iOS jo bere z zamikom)
const CAS_VELJAVNOSTI_URL_MS = 60000

export const PrenosDatoteke = {
  methods: {
    /**
     * Prenese datoteko iz data: URL-ja (base64 ali besedilo) ali iz navadnega/blob URL-ja.
     *
     * @param {string} href data:..., blob:... ali http(s) URL
     * @param {string} imeDatoteke ime, pod katerim se datoteka shrani
     */
    PrenesiDatoteko (href, imeDatoteke) {
      let url = String(href).trim()
      let objectUrl = null
      if (url.startsWith('data:')) {
        objectUrl = URL.createObjectURL(this.DataUrlVBlob(url))
        url = objectUrl
      }
      const povezava = document.createElement('a')
      povezava.href = url
      povezava.download = this.VarnoImeDatoteke(imeDatoteke)
      povezava.style.display = 'none'
      document.body.appendChild(povezava)
      povezava.click()
      povezava.remove()
      if (objectUrl !== null) {
        setTimeout(() => URL.revokeObjectURL(objectUrl), CAS_VELJAVNOSTI_URL_MS)
      }
    },
    /**
     * @param {string} dataUrl
     * @returns {Blob}
     */
    DataUrlVBlob (dataUrl) {
      const vejica = dataUrl.indexOf(',')
      const glava = dataUrl.substring(5, vejica)
      const vsebina = dataUrl.substring(vejica + 1)
      const deli = glava.split(';')
      const mimeType = deli[0] || 'application/octet-stream'
      if (!deli.includes('base64')) {
        return new Blob([decodeURIComponent(vsebina)], {type: mimeType})
      }
      const binarno = atob(vsebina.replace(/\s/g, ''))
      const bajti = new Uint8Array(binarno.length)
      for (let i = 0; i < binarno.length; i++) {
        bajti[i] = binarno.codePointAt(i)
      }
      return new Blob([bajti], {type: mimeType})
    },
    /**
     * Odstrani znake, ki v imenih datotek niso dovoljeni (iOS/macOS ne dovoli ":", Windows tudi ostalih).
     *
     * @param {string} ime
     * @returns {string}
     */
    VarnoImeDatoteke (ime) {
      return String(ime).replace(/[\\/:*?"<>|]/g, '-')
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/PrenosDatoteke.js